import {DATALAB_IFRAME_THEME_DARK, TThemeInfo} from "@/pages/datalab/pages/IframePage/types";

/**
 * 父页面切换主题后, iframe内容也切换
 *
 * @param themeInfo
 */
export const changeTheme = (themeInfo: TThemeInfo) => {
  if (themeInfo?.name === DATALAB_IFRAME_THEME_DARK) {
    document.body.style.filter = `invert(${themeInfo?.invert})`;
  } else {
    document.body.style.removeProperty("filter");
  }
};
